import { motion } from "framer-motion";
import SectionHeading from "components/layout/SectionHeading";
import { experienceData } from "constants/experience";

const Experience = () => {
  return (
    <section className="flex flex-col gap-y-12 text-center">
      <SectionHeading>Work Experience</SectionHeading>

      {experienceData.map((exp, index) => (
        <motion.article
          key={`${exp.company}-${exp.date}`}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.2 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.03 }}
          className="flex justify-center border border-black p-7 rounded-2xl shadow-md shadow-slate-200 bg-slate-200"
        >
          <article className="flex flex-col items-center gap-5 text-center">
            <span className="text-xl font-bold text-gray-800">{exp.title}</span>
            <span className="text-lg text-gray-600">{exp.company}</span>
            <span className="text-base text-gray-500">{exp.date}</span>
          </article>
        </motion.article>
      ))}
    </section>
  );
};

export default Experience;
